// Shared by hook instances and persisted for reloads and same-origin tabs.
export const READER_COOLDOWN_KEY = "goper:readers:cooldowns:v1";
export const READER_COOLDOWN_MS = 5 * 60 * 1000;
let resetInFlight = false;
let cachedRaw;
let cachedEntries = {};
function readEntries() {
  const raw = window.localStorage.getItem(READER_COOLDOWN_KEY);
  if (raw === cachedRaw) return cachedEntries;
  const entries = raw ? JSON.parse(raw) : {};
  if (!entries || typeof entries !== "object" || Array.isArray(entries)) {
    throw new Error("No se pudo validar la espera de los readers.");
  }
  for (const entry of Object.values(entries)) {
    if (
      !entry ||
      !Number.isFinite(entry.timestamp) ||
      !Number.isFinite(entry.duration) ||
      entry.duration <= 0
    ) {
      throw new Error("No se pudo validar la espera de los readers.");
    }
  }
  cachedRaw = raw;
  cachedEntries = entries;
  return entries;
}
export function readReaderCooldown(readerId) {
  const entry = readEntries()[readerId];
  return entry && entry.timestamp + entry.duration * 60000 > Date.now() ? entry : null;
}
export function readReaderCooldowns() {
  return Object.fromEntries(
    Object.entries(readEntries()).filter(
      ([, entry]) => entry.timestamp + entry.duration * 60000 > Date.now()
    )
  );
}
export function saveReaderCooldowns(readers, duration = READER_COOLDOWN_MS / 60000) {
  const entries = readReaderCooldowns();
  const timestamp = Date.now();
  for (const { id: readerId, hostname: readerName } of readers) {
    const current = entries[readerId];
    entries[readerId] = {
      readerId,
      readerName,
      deviceName: readerName,
      timestamp,
      duration,
      ...(current && current.timestamp + current.duration * 60000 > timestamp + duration * 60000
        ? current
        : {}),
    };
  }
  window.localStorage.setItem(READER_COOLDOWN_KEY, JSON.stringify(entries));
  window.dispatchEvent(new Event("goper:reader-cooldown"));
  return entries;
}
export function saveReaderCooldown(readerId, readerName, duration = 5) {
  return saveReaderCooldowns([{ id: readerId, hostname: readerName }], duration);
}
export function removeReaderCooldown(readerId) {
  const entries = readReaderCooldowns();
  delete entries[readerId];
  window.localStorage.setItem(READER_COOLDOWN_KEY, JSON.stringify(entries));
  window.dispatchEvent(new Event("goper:reader-cooldown"));
  return entries;
}
const busyResult = () => ({
  success: false,
  error: "Hay un reinicio en curso en este navegador. Espera a que termine.",
});
export async function withReaderResetLock(action) {
  const execute = async () => {
    if (resetInFlight) return busyResult();
    resetInFlight = true;
    try {
      return await action();
    } catch (error) {
      return {
        success: false,
        error: error.message || "No se pudo validar la espera. No se envió otro reinicio.",
      };
    } finally {
      resetInFlight = false;
    }
  };
  // Web Locks serializes operations across same-origin tabs, including group resets.
  if (typeof navigator.locks?.request === "function") {
    return navigator.locks.request("goper:readers:reset", { ifAvailable: true }, (lock) =>
      lock ? execute() : busyResult()
    );
  }
  return execute();
}
